<template>
    <div class="form-group row-grey row m-b-sm align-items-center list-header-row">
        <div class="col-md-auto">
            <h4>{{ __('transfer_list') }}: <strong>{{ displayType }}</strong></h4>
        </div>

        <div class="col-md-auto text-right header-label">
            <h4>{{ __('from_account') }}:</h4>
        </div>
        <div :class="{'has-error': list.errors.account}" class="col-md-2">
            <select2
                :settings="{ width: '100%' }"
                v-model="list.account"
                :options="optionsName"
                name="account"
                @input="$emit('setAccountName', $event, list)"
            />
            <span v-if="list.errors.account" class="help-block text-danger">
                {{ __('validation_required_from_account') }}
            </span>
        </div>

        <div class="col-md-auto header-currency">
            <h4>{{ currency }}</h4>
        </div>

        <div :class="{'has-error': list.errors.account}" class="col-md-2">
            <select2
                :settings="{ width: '100%' }"
                v-model="list.account"
                :options="optionsNrb"
                name="account_nrb"
                @input="$emit('setAccountName', $event, list)"
                :disabled="parseInt(list.account) === -1"
            />
            <span v-if="list.errors.account" class="help-block text-danger">
                {{ __('validation_required_from_account') }}
            </span>
        </div>

        <div class="col-md-auto text-right">
            <h4>{{ __('of_day') }}:</h4>
        </div>
        <div :class="{'has-error': list.errors.due_date}" class="col-md-auto">
            <datepicker :start_date="today" :value="list.due_date"
                        style="max-width: 130px;"
                        @input="$emit('confirmDatePicker', $event, list)"
            />
            <span v-if="list.errors.due_date" class="help-block text-danger">
                {{ __('validation_required_of_day') }}
            </span>
        </div>

        <div class="col-md-auto text-right">
            <h4>{{ __('transfer_list_name') }}:</h4>
        </div>
        <div :class="{'has-error': list.errors.description}" class="col header-name">
            <input v-model="list.description" class="form-control" type="text">
            <span v-if="list.description && list.description.length > 50" class="help-block text-danger">
                {{ __('generating_transfers_description_to_long_message') }}
            </span>
            <span v-else-if="list.errors.description" class="help-block text-danger">
                {{ __('validation_required_transfer_list_name') }}
            </span>
        </div>

        <div v-if="type !== 'other'" class="col-md-auto ml-auto text-right">
            <button v-if="list_index > 0"
                    :disabled="list.transfers.length > 0"
                    class="btn btn-danger btn-sm"
                    type="button"
                    @click="$emit('removeList', type, list_index)">{{ __('remove_list') }}
            </button>
            <button v-if="list_index === lists - 1"
                    class="btn btn-primary btn-sm"
                    type="button"
                    @click="$emit('addList', type)">{{ __('add_list') }}
            </button>
        </div>
       <div class="col" style="min-width: 500px; max-height: 20px" >
           <h5 style="font-size: 11px !important;" v-html="owner"></h5>
       </div>

        <!-- Rachunek do opłat - tylko listy IBAN-SEPA oraz IBAN-SWIFT.
             Wiersz pojawia się dopiero po wybraniu rachunku powyżej. -->
        <div v-if="showChargeRow" class="col-12 charge-row">
            <div class="row align-items-center m-t-xs">
                <!-- pusta kolumna wyrównująca pola do wiersza powyżej -->
                <div aria-hidden="true" class="col-md-auto d-none d-md-block header-spacer">
                    <h4>{{ __('transfer_list') }}: <strong>{{ displayType }}</strong></h4>
                </div>

                <div class="col-md-auto text-right header-label">
                    <h4>{{ __('charges_from') }}:</h4>
                </div>
                <div class="col-md-2">
                    <select2
                        :settings="{ width: '100%' }"
                        v-model="list.charge_payment_source_id"
                        :options="chargeOptionsName"
                        name="charge_account"
                        @input="$emit('setChargeAccount', $event, list)"
                    />
                </div>

                <div class="col-md-auto header-currency">
                    <h4>{{ chargeCurrency }}</h4>
                </div>

                <div class="col-md-2">
                    <select2
                        :settings="{ width: '100%' }"
                        v-model="list.charge_payment_source_id"
                        :options="chargeOptionsNrb"
                        name="charge_account_nrb"
                        @input="$emit('setChargeAccount', $event, list)"
                    />
                </div>

                <template v-if="type === 'iban_swift'">
                    <div class="col-md-auto text-right">
                        <h4>{{ __('charge_bearer') }}:</h4>
                    </div>
                    <div class="col-md-auto">
                        <select v-model="list.charge_bearer" class="form-control charge-bearer-select">
                            <option value="sha">{{ __('charge_bearer_sha') }}</option>
                            <option value="our">{{ __('charge_bearer_our') }}</option>
                            <option value="ben">{{ __('charge_bearer_ben') }}</option>
                        </select>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ListHeader",
    props: [
        'list', 'type', 'list_index', 'optionsName', 'optionsNrb', 'currency', 'lists', 'today', 'owner',
        'chargeOptionsName', 'chargeOptionsNrb', 'chargeCurrency'
    ],
    computed: {
        displayType: function () {
            if (this.type === 'other') return this.__(this.type);

            let display = this.type;
            return display.replace('_', ' ').toUpperCase();
        },
        //wiersz opłat dotyczy tylko list IBAN-SEPA oraz IBAN-SWIFT
        //i pojawia się dopiero po wybraniu rachunku powyżej
        showChargeRow: function () {
            if (this.type !== 'iban_sepa' && this.type !== 'iban_swift') return false;

            return parseInt(this.list.account) > 0;
        }
    }
}
</script>

<style scoped>
/* belka listy jest ciemna (patrz .row-grey w GenerateTransferList) - opisy na biało,
   a przyciski odwrotnie: białe tło i ciemna czcionka */
h4,
h5 {
    color: #fff;
}

.btn {
    background-color: #fff;
    border-color: #fff;
    color: #495966;
}

/* .form-control i .input-group-addon mają color: inherit, więc na ciemnej belce
   dziedziczyły biel - wpisana data, nazwa listy i ikona kalendarza były niewidoczne.
   >>> bo datepicker to komponent potomny (scoped nie wchodzi do jego wnętrza) */
.form-control,
.input-group-addon,
.row-grey >>> .form-control,
.row-grey >>> .input-group-addon {
    color: #495966;
}

/* węższe odstępy między polami belki - przy powiększeniu 125% nazwa listy
   i przycisk "Dodaj listę" spadały do drugiej linii */
.list-header-row > [class*="col"],
.list-header-row .row > [class*="col"] {
    padding-left: 5px;
    padding-right: 5px;
}

.list-header-row > [class*="col"]:first-child {
    padding-left: 15px;
}

/* Wiersz opłat ma być wyrównany w kolumnach z wierszem rachunku powyżej, a
   jest osobnym .row zagnieżdżonym w kolumnie belki: żeby jego kolumny zaczynały
   się w tych samych miejscach, kontener musi mieć odstępy takie jak .list-header-row
   (15px, nie 5px z reguły wyżej), a pusta kolumna wyrównująca - takie jak pierwsza
   kolumna belki. Bez tego oba rachunki rozjeżdżały się o 20px. */
.list-header-row > [class*="col"].charge-row {
    padding-left: 15px;
    padding-right: 15px;
}

.list-header-row .row > [class*="col"].header-spacer {
    padding-left: 15px;
}

/* wiersz opłat ma być wyrównany w kolumnach z wierszem rachunku powyżej */
@media (min-width: 768px) {
    .header-spacer {
        visibility: hidden;
    }

    .header-label {
        width: 100px;
        white-space: nowrap;
    }

    .header-currency {
        min-width: 45px;
    }

    /* nazwa listy zajmuje miejsce, ktore zostaje do przyciskow */
    .header-name {
        min-width: 120px;
        max-width: 250px;
    }
}

/* szerokość dopasowana do najdłuższej (domyślnej) wartości */
.charge-bearer-select {
    width: auto;
    max-width: 100%;
}
</style>
